// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.hashpack.wallet",
    name: "HashPack",
    homepage: "https://hashpack.app",
    image_id: "8d55dd5a-7c9f-4929-d2d1-00564e41ac00",
    app: {
        browser: "https://wallet.hashpack.app/",
        ios: "https://apps.apple.com/app/id6444389849",
        android: "https://play.google.com/store/apps/details?id=app.hashpack.wallet.twa",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/hashpack/gjagmgiddbbciopjhllkdnddhcglnemk",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.hashpack.wallet",
    mobile: {
        native: "hashpack://",
        universal: "https://link.hashpack.app",
    },
    desktop: {
        native: null,
        universal: "https://link.hashpack.app",
    },
};
//# sourceMappingURL=index.js.map